// extracted by mini-css-extract-plugin
module.exports = {"scroll":"horizontalScroll-module--scroll--2P9Kj"};